import { State } from 'screens/BrokerPortal/screens/Registration/store/types';

const exportFunc = (searchFirmForm: State['searchFirms']['form']): boolean => {
  return searchFirmForm.firmId !== null && searchFirmForm.firmId !== undefined;
};

export default exportFunc;
